import { render, staticRenderFns } from "./AddList.vue?vue&type=template&id=d2dd6af6"
import script from "./AddList.vue?vue&type=script&lang=js"
export * from "./AddList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports